<div class="user-view">
  <div class="pane left" appUserManual [userManualKey]="'user-view'">
    <div class="user-filter-field">
      <p-floatlabel variant="in">
        <p-iconfield class="user-search-shell">
          <input pInputText id="user-filter" type="text" [formControl]="filter" autocomplete="off"
                 class="user-search-input" />

          <div class="user-search-actions">
            @if (filter.value) {
              <button pButton type="button" class="scope-inline-action scope-inline-action--clear" aria-label="Clear"
                      (click)="filter.setValue('')">
                <i class="pi pi-times"></i>
              </button>
            }
          </div>
        </p-iconfield>
        <label for="user-filter">Filter by username</label>
      </p-floatlabel>
    </div>

    <div class="user-list" role="listbox" aria-label="Users with open scope">
      @for (user of (filteredUsers$ | async); track user.id) {
        <button
          type="button"
          class="user-list-item"
          [class.selected]="(selectedUser$ | async)?.id === user.id"
          (click)="selectUser(user)"
        >
          <span class="username">{{ user.name }}</span>
          <span class="display-name">{{ user.userName }}</span>
        </button>
      }
    </div>
  </div>

  <div class="pane right">
    <p-confirmdialog></p-confirmdialog>

    @if (selectedUser$ | async; as selected) {
      <div class="selected-scopes">
        <h3>Assigned scope for {{ selected.name }}</h3>

        <div class="scope-toolbar">
          <div class="scope-search-field">
            <p-floatlabel variant="in">
              <p-iconfield class="scope-search-shell">
                <input
                  pInputText
                  id="scope-search"
                  [formControl]="scopeSearch"
                  (keyup.enter)="findTag()"
                  autocomplete="off"
                  class="scope-search-input"
                />

                <div class="scope-search-actions">
                  <button pButton type="button" class="scope-inline-action" aria-label="Search" (click)="findTag()">
                    <i class="pi pi-search"></i>
                  </button>
                  @if (scopeSearch.value && scopeSearch.value.length) {
                    <button pButton type="button" class="scope-inline-action scope-inline-action--clear"
                            aria-label="Clear"
                            (click)="scopeSearch.setValue(''); clearHighlight()">
                      <i class="pi pi-times"></i>
                    </button>
                  }
                </div>
              </p-iconfield>
              <label for="scope-search">Search by tag number</label>
            </p-floatlabel>
          </div>

          <button
            pButton
            type="button"
            class="auto-refresh-btn"
            [class.active]="autoRefreshing$ | async"
            [class.spin-once]="spinAnimating"
            (click)="toggleAutoRefresh()"
            [disabled]="!selected?.id"
            [attr.aria-pressed]="(autoRefreshing$ | async) === true"
            [attr.title]="(autoRefreshing$ | async) ? 'Auto refresh is ON' : 'Auto refresh is OFF'"
          >
            <i class="pi pi-sync"></i>
          </button>
        </div>

        @if (groups$ | async; as groups) {
          @if (groups.length === 0) {
            <div class="empty-state">No open scope.</div>
          }

          @for (group of groups; track group.packageKey) {
            <div class="package-group">
              <div class="package-header" (click)="toggleGroup(group.packageKey)" role="button" tabindex="0">
                <div class="package-title">Package: {{ group.packageNumber }}</div>

                <div class="package-progress" aria-label="Procurement package progress">
                  <div
                    class="progress-track"
                    role="progressbar"
                    [attr.aria-valuenow]="getGroupProgress(group)"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div class="progress-fill" [style.width.%]="getGroupProgress(group)"></div>
                  </div>
                  <div class="progress-label">{{ getGroupProgress(group) }}%</div>
                </div>

                <div class="package-meta">{{ group.assignments.length }} assignments</div>

                @if (canUnlinkScoped && group.expanded) {
                  <button
                    pButton
                    type="button"
                    class="unlink-toggle-btn"
                    (click)="$event.stopPropagation(); toggleUnlinkPanel(group.packageKey)"
                    title="Show unlink tools"
                  >
                    <i class="pi pi-link"></i>
                    <i class="pi pi-times unlink-toggle-btn__overlay"></i>
                  </button>
                }

                <button pButton type="button" class="toggle-btn" aria-label="Toggle group" tabindex="-1">
                  <i [class]="group.expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
                </button>
              </div>

              @if (group.expanded) {
                <div class="package-body">
                  @if (canUnlinkScoped && isUnlinkPanelVisible(group.packageKey)) {
                    <div class="unlink-panel">
                      <div class="unlink-toolbar">
                        <div class="unlink-filter">
                          <p-floatlabel variant="in">
                            <p-iconfield class="scope-search-shell">
                              <input
                                pInputText
                                [formControl]="getUnlinkFilterControl(group.packageKey)"
                                autocomplete="off"
                                class="scope-search-input"
                                [id]="'unlink-filter-' + group.packageKey"
                              />
                            </p-iconfield>
                            <label [for]="'unlink-filter-' + group.packageKey">Filter checksheets
                              in {{ group.packageNumber }}</label>
                          </p-floatlabel>
                        </div>

                        <button
                          pButton
                          type="button"
                          class="unlink-action-chip"
                          (click)="openUnlinkConfirmation(group)"
                          [disabled]="isUnlinkDisabled(group.packageKey)"
                          title="Unlink selected checksheets"
                        >
                          <i class="pi pi-link unlink-action-chip__icon"></i>
                          <i class="pi pi-times unlink-action-chip__icon unlink-action-chip__icon--overlay"></i>
                          <span class="unlink-action-chip__label">Unlink selected</span>
                        </button>
                      </div>

                      <p-table
                        [value]="getFilteredAssignmentsForUnlink(group)"
                        [tableStyle]="{ 'min-width': '100%', 'table-layout': 'fixed' }"
                        class="p-datatable-sm scope-table unlink-table"
                      >
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="select-column">
                              <input
                                type="checkbox"
                                [checked]="areAllSelectedForUnlink(group.packageKey)"
                                (change)="toggleAllSelectionsForUnlink(group.packageKey)"
                              />
                            </th>
                            <th>CommPkg</th>
                            <th>McPkg</th>
                            <th>System</th>
                            <th>Tag</th>
                            <th>CheckSheet</th>
                            <th>Company</th>
                            <th>McSite</th>
                            <th>Phase</th>
                            <th>Status</th>
                            <th class="progress-column">Progress</th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-a>
                          <tr [attr.id]="'assignment-' + a.id" [class.highlight]="a.id === highlightedAssignmentId">
                            <td class="select-column">
                              <input
                                type="checkbox"
                                [checked]="isAssignmentSelectedForUnlink(group.packageKey, a.id)"
                                (change)="toggleAssignmentSelectionForUnlink(group.packageKey, a.id)"
                              />
                            </td>
                            <td>{{ a.commissioningPackageNumber }}</td>
                            <td>{{ a.mcPackageNumber }}</td>
                            <td>{{ a.systemNumber || '-' }}</td>
                            <td>{{ a.tagNumber || '-' }}</td>
                            <td>{{ a.checkSheetNumber }}</td>
                            <td>{{ a.companyNumber }}</td>
                            <td>{{ a.sitenUmber }}</td>
                            <td>{{ a.phaseNumber }}</td>
                            <td class="status-cell">
                              <app-status-circle [status]="toCompletionStatus(a.status || a.state)"></app-status-circle>
                            </td>
                            <td class="progress-cell">
                              <div class="progress-track" role="progressbar" [attr.aria-valuenow]="getProgress(a)"
                                   aria-valuemin="0" aria-valuemax="100">
                                <div class="progress-fill" [style.width.%]="getProgress(a)"></div>
                              </div>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  }

                  <div class="package-table">
                    <p-table
                      [value]="group.assignments"
                      [tableStyle]="{ 'min-width': '100%', 'table-layout': 'fixed' }"
                      class="p-datatable-sm scope-table"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th>CommPkg</th>
                          <th>McPkg</th>
                          <th>System</th>
                          <th>Tag</th>
                          <th>CheckSheet</th>
                          <th>Company</th>
                          <th>McSite</th>
                          <th>Phase</th>
                          <th>Status</th>
                          <th class="progress-column">Progress</th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-a>
                        <tr [attr.id]="'assignment-' + a.id" [class.highlight]="a.id === highlightedAssignmentId">
                          <td>{{ a.commissioningPackageNumber }}</td>
                          <td>{{ a.mcPackageNumber }}</td>
                          <td>{{ a.systemNumber || '-' }}</td>
                          <td>{{ a.tagNumber || '-' }}</td>
                          <td>{{ a.checkSheetNumber }}</td>
                          <td>{{ a.companyNumber }}</td>
                          <td>{{ a.sitenUmber }}</td>
                          <td>{{ a.phaseNumber }}</td>
                          <td class="status-cell">
                            <app-status-circle [status]="toCompletionStatus(a.status || a.state)"></app-status-circle>
                          </td>
                          <td class="progress-cell">
                            <div class="progress-track" role="progressbar" [attr.aria-valuenow]="getProgress(a)"
                                 aria-valuemin="0" aria-valuemax="100">
                              <div class="progress-fill" [style.width.%]="getProgress(a)"></div>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              }
            </div>
          }
        }
      </div>
    } @else {
      <div class="empty-state">Select a user to see open scope.</div>
    }
  </div>
</div>
